
import { defineComponent } from '@vue/runtime-core'

import { getSearchPreviewForecast } from '@/api'
import { ISearchCompany } from '@/models'

import SearchInput from './SearchInput.vue'
import SearchResult from './SearchResult.vue'

// App.directive('demo', (el, binding) => {
//     console.log(binding.value.color) // => "white"
//     console.log(binding.value.text) // => "hello!"
// })

export default defineComponent({
    components: {
        SearchInput,
        SearchResult,
    },

    props: {
        api: {
            type: String,
            required: true,
        },
        url: {
            type: String,
            required: true,
        },
    },

    data() {
        return {
            previewForecasts: [] as ISearchCompany[],
            searchText: '',
        }
    },

    methods: {
        async search(searchText: string) {
            this.searchText = searchText
            this.previewForecasts = searchText ? await getSearchPreviewForecast(this.api, searchText) : []
        },
    },
})
